import React, { forwardRef, useEffect, useRef, useState } from "react";

const Spotify = forwardRef(function Spotify({ ...props }, ref) {
  const pathRef = useRef(null);
  const [vb, setVb] = useState("0 0 236.05 225.25"); // initial

  useEffect(() => {
    const p = pathRef.current;
    if (!p) return;
    const b = p.getBBox();
    const s = Math.max(b.width, b.height);
    const vx = b.x - (s - b.width) / 2;
    const vy = b.y - (s - b.height) / 2;
    setVb(`${vx} ${vy} ${s} ${s}`);
  }, []);

  return (
    <svg
      ref={ref}
      viewBox={vb}
      width={props.size}
      height={props.size}
      preserveAspectRatio="xMidYMid meet"
      style={{ display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        ref={pathRef}
        fill={
          props.color === "white" || props.color === "mobile-nav"
            ? "#ffffff"
            : props.color
        }
        d="m122.37,3.31C61.99.91,11.1,47.91,8.71,108.29c-2.4,60.42,44.61,111.26,104.98,113.66,60.38,2.4,111.26-44.6,113.66-104.98C229.74,56.59,182.74,5.7,122.37,3.31Zm46.18,160.28c-1.36,2.4-4.01,3.6-6.59,3.24-.79-.11-1.58-.37-2.32-.79-14.46-8.23-30.22-13.59-46.84-15.93-16.62-2.34-33.25-1.53-49.42,2.4-3.51.85-7.04-1.3-7.89-4.81-.85-3.51,1.3-7.04,4.81-7.89,17.78-4.32,36.06-5.21,54.32-2.64,18.26,2.57,35.58,8.46,51.49,17.51,3.13,1.79,4.23,5.77,2.45,8.91Zm14.38-28.72c-2.23,4.12-7.39,5.66-11.51,3.43-16.92-9.15-35.24-15.16-54.45-17.86-19.21-2.7-38.47-1.97-57.26,2.16-1.02.22-2.03.26-3.01.12-3.41-.48-6.33-3.02-7.11-6.59-1.01-4.58,1.89-9.11,6.47-10.12,20.77-4.57,42.06-5.38,63.28-2.4,21.21,2.98,41.46,9.62,60.16,19.74,4.13,2.23,5.66,7.38,3.43,11.51Zm15.94-32.38c-2.1,4.04-6.47,6.13-10.73,5.53-1.15-.16-2.28-.52-3.37-1.08-19.7-10.25-40.92-17.02-63.07-20.13-22.15-3.11-44.42-2.45-66.18,1.97-5.66,1.15-11.17-2.51-12.32-8.16-1.15-5.66,2.51-11.17,8.16-12.32,24.1-4.89,48.74-5.62,73.25-2.18,24.51,3.44,47.99,10.94,69.81,22.29,5.12,2.66,7.11,8.97,4.45,14.09Z"
      />
    </svg>
  );
});
Spotify.displayName = "Spotify";
export default Spotify;
